export default {
  pageTitle: {
    en: "Account Verification",
    ja: "アカウントの確認"
  },
  pageSubtitle: {
    en: "Verify your account to have an access to the MMPro services",
    ja: "MMProのサービスを利用するためのアカウント認証について"
  },

  documentsWarning: {
    en: "Please make sure that all the information provided is valid and real-life in accordance with your ID documents.",
    ja: "本人確認書類に基づき、記載された内容が有効かつ現実的なものであることをご確認ください。"
  },
  noChangeWarning: {
    en: "You will have no opportunity to change the personal information after verification.",
    ja: "お客様は、認証後に個人情報を変更することはできません。"
  },

  automaticallySave: {
    en: "We automatically save all input data you add in this form.",
    ja: "このフォームで追加された入力データは、自動的に保存されます。"
  },

  termOfUse: {
    en: "This information is used for KYC only. MMPro keeps confidentially your personal data in accordance with GDPR.",
    ja: "この情報は、KYCのためにのみ使用されます。MMProは、GDPRに基づき、お客様の個人データを機密として保持します。"
  },

  buttonTextVerify: {
    en: "Verify personal data",
    ja: "個人情報の確認"
  },
  buttonTextCheck: {
    en: "We check your personal data",
    ja: "私たちはあなたの個人データをチェックします"
  },

  accountVerified: {
    en: "Congratulations! You verified your account",
    ja: "おめでとう！ アカウントを確認しました"
  }
}
